import React,{useEffect,useState} from "react";
import { Button,ListBox,ListBoxItem,Popover,Select,SelectValue } from "react-aria-components";
import type { ListBoxItemProps } from "react-aria-components";
import { Check,ChevronExpand } from "react-bootstrap-icons";
import styles from "./product_status_dropdown.module.css";

interface IStatusItem {
    id: string;
    name: string;
    color: string;
}

interface IProductStatusDropdownProps {
    productStatusArray: IStatusItem[];
    selectedStatus: string;
    onStatusChange: (newStatus: string) => void;
}

export const ProductStatusDropdown:React.FC<IProductStatusDropdownProps> = ({
    productStatusArray,
    selectedStatus,
    onStatusChange,
}) => {
    const [selectedItemId, setSelectedItemId] = useState<string>('');

    useEffect(() => {
        setSelectedItemId(selectedStatus);
    }, [selectedStatus]);

    return (
    <Select 
    className={"d-flex position-relative"}
    style={{width:220}}
    selectedKey={selectedItemId}
    onSelectionChange={key => {
        if (key != null) {
          const newKey = String(key);
          setSelectedItemId(newKey);
          onStatusChange?.(newKey);
        }
      }}
    >
        <Button
        className={
          'btn btn-light d-flex align-items-center justify-content-between w-100 text-start ' +
          styles.dropDownButton
        }
      >
        <SelectValue className="flex-grow-1 text-truncate" />
        <ChevronExpand className={`ms-2 ${styles.dropDownIcon}`} size={16} />
      </Button>

      <Popover
        className={"dropdown-menu show mt-1 w-100 "+styles.list_style}
        style={{ maxHeight: 240, maxWidth: 220, overflowY: 'auto' }}
      >
        <ListBox className={"list-unstyled mb-0"} items={productStatusArray}>
          {(item: IStatusItem) => (
            <StatusItem
              id={item.id}
              key={item.id}
              textValue={item.name || item.id}
            >
              <Status color={item.color} />
              {item.name || item.id}
            </StatusItem>
          )}
        </ListBox>
      </Popover>
    </Select>
  );
};

function StatusItem(
  props: ListBoxItemProps & { children: React.ReactNode }
) {
  return (
    <ListBoxItem
      {...props}
      className="px-3 py-2"
    >
      {({ isSelected, isFocused, isHovered }) => {
        const rowClass = [
          'd-flex',
          'align-items-center',
          'justify-content-between',
          'rounded-1',
          styles.dropDownItemRow,
          isFocused ? 'bg-primary text-white' : ''
        ]
          .filter(Boolean)
          .join(' ');

        const textClass = [
          'd-flex',
          'align-items-center',
          'gap-2',
          'text-truncate',
          isSelected && !isFocused ? 'fw-semibold text-primary' : 'fw-normal'
        ]
          .filter(Boolean)
          .join(' ');

        const iconClass = [
          'd-flex',
          'align-items-center',
          'justify-content-center',
          'ms-2',
          isFocused || isHovered ? 'text-white' : 'text-primary'
        ]
          .filter(Boolean)
          .join(' ');

        return (
          <div className={rowClass}>
            <span
              className={`${textClass} ${styles.dropDownText}`}
            >
              {props.children}
            </span>
            <span className={iconClass} style={{ width: 20 }}>
              {isSelected && <Check size={16} />}
            </span>
          </div>
        );
      }}
    </ListBoxItem>
  );
}

function Status({ color }: { color: string }) {
  return (
    <span
      className="rounded-circle border border-white p-1"
      style={{
        width: 10,
        height: 10,
        display: 'inline-block',
        backgroundColor: color || 'transparent'
      }}
    />
  );
}